// extracted by mini-css-extract-plugin
export default {"main":"M1hv08Saat6oRJv0Gy45","common_bganimation":"E25MY3z53Jkvp8hq3lQi"};